// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2022":"0a7db4b4","3327":"2c88f91d"}[chunkId] + ".chunk.css";
};